import { Link } from "react-router-dom";
import {
  Button,
  Header,
  HeaderContainer,
  HeaderName,
  HeaderGlobalBar,
  HeaderGlobalAction,
} from "@carbon/react";
import { Close } from "@carbon/react/icons";
import { SwitchAppIconButton } from "../../../components";

export const View = ({ handleComplete, handleCancel, isCompleteEnabled }) => {
  return (
    <HeaderContainer
      render={({ isSideNavExpanded, onClickSideNavExpand }) => (
        <Header
          className="header-transparency-cover onboarding-header"
          aria-label="Save and continue"
        >
          <SwitchAppIconButton
            onClick={handleCancel}
            size="md"
            className="close-icon--button mr-5"
          >
            <Close style={{ width: "30px", height: "30px" }} />
          </SwitchAppIconButton>
          <span className="font-ctm--bold">Activate Your Account</span>

          <HeaderGlobalBar>
            <Button
              className="switchapp-themed mr-5"
              kind="tertiary"
              size="sm"
              onClick={handleCancel}
            >
              Save for later
            </Button>

            {/* <Button
              className="switchapp-themed onboarding-header--button"
              size="sm"
              disabled={!isCompleteEnabled}
              onClick={handleComplete}
            >
              Activate profile
            </Button> */}
          </HeaderGlobalBar>
        </Header>
      )}
    />
  );
};
